import { useTranslation } from "react-i18next";
import { ContactUpdateInquiriesDefaultEndPage } from "./ContactUpdateInquiriesDefaultEndPage";

export const ContactUpdateInquiriesUpdateSuccessPage = () => {
	const { t } = useTranslation();

	return (
		<ContactUpdateInquiriesDefaultEndPage
			headline={t("Thank you for your feedback")}
			text={t("Your contact details have been successfully saved.")}
		/>
	);
};
